import { Product } from './magento/graphql.service';

interface AdditionalGTMProductInfo {
  item_list_id?: number;
  item_list_name?: string;
  quantity?: number;
}

/**
 * Turn GraphQL product into a GTM product for tracking
 * Not all fields are available all the time, so you need to provide what you have
 */
export function transformProductToGTMItem(product: Product, additionalInfo?: AdditionalGTMProductInfo) {
  return {
    item_id: product.sku,
    item_name: product.name,
    item_brand: product.manufacturer,
    item_category: product.categories && product.categories[0],
    item_category2: product.categories && product.categories[1],
    item_category3: product.categories && product.categories[2],
    item_category4: product.categories && product.categories[3],
    item_category5: product.categories && product.categories[4],
    item_list_id: additionalInfo?.item_list_id,
    item_list_name: additionalInfo?.item_list_name,
    // item_variant: product.variant,
    price: product.price.reduced ?? product.price.regular,
    discount: product.price.discount,
    quantity: additionalInfo?.quantity,
  };
}
